"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Display multiple values in one cell, allowing for highlighting of red with icon
 * Example Dashboard is the CBITS: Group Leader dashboard - Student View--Fear Thermometer
 *
 * Output in a cell:
 *   7 Beginning
 *   8 Peak !
 *   6 End
 *   
 * "settings": {
        "renderAs": "mappingList",
        "threshold": "8",
        "mapping": {
            "Session1.devTags.FearThermometerBeg": " Beginning",
            "Session1.devTags.FearThermometerPeak": " Peak",
            "Session1.devTags.FearThermometerEnd": " End"
        },
        "icon": {
            "name": "warning",
            "paths": [
                "M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM576 832h-128v-128h128v128zM576 576h-128v-384h128v384z"
            ],
            "viewBox": "0 0 1024 1024",
            "color": "red"
        }
    }
 */
var MappingList = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(MappingList, _React$Component);
  function MappingList() {
    _classCallCheck(this, MappingList);
    return _callSuper(this, MappingList, arguments);
  }
  _createClass(MappingList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        row = _this$props.row,
        settings = _this$props.settings;
      var displayValues = {};
      displayValues = Object.keys(settings.mapping).map(function (path) {
        return /*#__PURE__*/_react["default"].createElement("p", {
          key: path,
          className: "".concat(row[path] >= settings.threshold && settings.threshold !== '' ? _style["default"].highlight : '')
        }, row[path] !== null ? "".concat(row[path], " ").concat((0, _get2["default"])(settings.mapping, path)) : null, ' ', row[path] !== null && row[path] >= settings.threshold ? settings.icon && /*#__PURE__*/_react["default"].createElement("span", {
          color: settings.icon.color
        }, /*#__PURE__*/_react["default"].createElement("svg", {
          fill: settings.icon.color,
          className: settings.icon.name,
          xmins: "http://www.w3.org/2000/svg",
          viewBox: settings.icon.viewBox,
          width: "15",
          height: "15"
        }, /*#__PURE__*/_react["default"].createElement("g", null, settings.icon.paths.map(function (p) {
          return /*#__PURE__*/_react["default"].createElement("path", {
            key: p,
            d: p
          });
        })))) : null);
      });
      return /*#__PURE__*/_react["default"].createElement("div", null, displayValues);
    }
  }]);
  return MappingList;
}(_react["default"].Component);
_defineProperty(MappingList, "propTypes", {
  settings: _propTypes["default"].object,
  items: _propTypes["default"].array,
  row: _propTypes["default"].object
});